import calculate from 'src/utils/calculate'
import { addHome, deleteHome, editHome } from './utils/home'

const actions = {
  async getData({ dispatch }, { params }) {
    const updateView = () => {
      const { baseReportName, routeName } = params
      const endpointKey = baseReportName || routeName
      return dispatch('tools/updateView', { endpointKey }, { root: true })
    }

    return updateView()
  },

  async getHomeCard({ dispatch }, { metric, params, query }) {
    const { metricType, metricGroupBy } = metric
    const endpointKey = params.baseReportName || params.routeName
    const data = await dispatch('tools/request', { endpointKey, params, query }, { root: true })
    const items = await dispatch('tools/transform', { endpointKey, data, query }, { root: true })
    const groups = await dispatch('tools/applyReportCriteria', { items, params, query }, { root: true })

    return {
      metricType,
      metricGroupBy,
      [metricType.value]: calculate[metricType.value](groups),
      [metricGroupBy.value]: calculate[metricGroupBy.value](groups),
    }
  },

  errorSaving({ commit }, error) {
    const message = `Error Saving Home: ${error.message}`
    const status = 'error'

    commit('tools/snackbar', true, { root: true })
    commit('tools/snack', { message, status }, { root: true })

    return error
  },
  submitFormHome({ commit, dispatch }, home) {
    const saveEdits = async () => {
      const changes = { home }
      const fnSuccess = () => {
        const message = 'Home Saved'
        const status = 'success'

        commit('tools/snackbar', true, { root: true })
        commit('tools/snack', { message, status }, { root: true })
      }

      return dispatch('auth/handleUpdateToUserSettings', { changes, fnSuccess }, { root: true })
    }
    const catcher = (error) => dispatch('errorSaving', error)

    return saveEdits().catch(catcher)
  },

  addHome({ getters }, homeToAdd) {
    return addHome(homeToAdd, getters.homes)
  },
  editHome({ getters }, { homeEdits, indexToEdit }) {
    return editHome(indexToEdit, homeEdits, getters.homes)
  },
  removeHome({ getters }, indexToDelete) {
    return deleteHome(indexToDelete, getters.homes)
  },

  async prepareToCreateHome({ commit, dispatch, getters }, { selectedReport }) {
    const { setDefaultMetricSettings } = getters
    const endpointKey = selectedReport.baseReportName || selectedReport.routeName

    setDefaultMetricSettings(endpointKey, selectedReport)

    const home = await dispatch('addHome', selectedReport)
    commit('formHome', { action: 'create', entry: home, scope: 'item' })
  },

  async createHome({ dispatch, state }) {
    const home = state.formHome.entry
    return dispatch('submitFormHome', home)
  },
  async deleteHome({ dispatch }, indexToDelete) {
    const home = await dispatch('removeHome', indexToDelete)
    return dispatch('submitFormHome', home)
  },
  async updateHome({ dispatch }, { selectedItem, selectedReport }) {
    selectedReport.metricGroupBy = selectedItem.metricGroupBy?.value
    selectedReport.metricType = selectedItem.metricType?.value

    const home = await dispatch('editHome', {
      homeEdits: selectedReport,
      indexToEdit: selectedItem.index,
    })

    return dispatch('submitFormHome', home)
  },
}

export default actions
